import { PDFDocument } from 'pdf-lib';
import {
	addDocumentSign,
	updateTemplate
} from '../../../../Services/api-config.js';
import {
	handleAdditionalCharges,
	setPreviewDataAction
} from '../../../../Store/Redux/file-list-slice.js';
import { mapTables } from '../../../../utils/map-tables.js';
import {
	getDropdownFields,
	getInputFields
} from '../../../../utils/ck-map-input-fields.js';
import { updateContent } from '../../../../Store/Redux/ckeditor-slice.js';
import generateThumbnail from '../../../../utils/generate-thumbnail.js';
import { pageSizes } from '../../../../utils/page-sizes.js';
import customToast from '../../../Common/custom-toast.js';
import {
	getErrorMessage,
	getMobileValue,
	multiply,
	subtract
} from '../../../../utils/util.js';

export const mapTemplateData = async ({
	base64,
	templatePayload,
	getSignCoordinates,
	tempDiv,
	htmlData,
	setIsLoading,
	navigate,
	dispatch,
	documentID,
	storedRecipients,
	enableDownload,
	getPicture,
	getLocation,
	stampBase64,
	arrayOne,
	stampConfig,
	additionalCharges,
	isAdditionalAmountRequired
}) => {
	const loadPdf = await PDFDocument.load(base64);
	const pdfPages = loadPdf.getPages();

	// If template doesnt has any signatures
	const mapRecipients = mapDefaultFields(storedRecipients, pdfPages, false);

	for (const tc of arrayOne?.templateInfoConfig ?? []) {
		const sn = templatePayload.selectedRecipients.find((r) => r.name === tc.id);
		if (sn) {
			tc.uuid = sn.uuid;
		}
	}

	const templatePayloadObj = {
		documentPdf: base64,
		// EnableOtp,
		enableDownload,
		getPicture,
		getLocation,
		recipientData: [],
		templateInfoConfig: arrayOne?.templateInfoConfig,
		stampConfig: stampConfig.stampConfig,
		...isAdditionalAmountRequired,
		...additionalCharges
	};

	const updatedTemplatePayload = {
		...templatePayloadObj,
		docId: documentID,
		isTemplate: true
	};
	await templateRecipientCoord(
		getSignCoordinates,
		tempDiv,
		stampBase64,
		mapRecipients,
		updatedTemplatePayload
	);

	if (stampBase64.length > 0 && [...getSignCoordinates]?.length > 0) {
		const mapStampDeafultcoord = mapDefaultFields(
			storedRecipients,
			stampBase64,
			false
		);
		for (const item of storedRecipients) {
			const findRecp = updatedTemplatePayload.recipientData.find(
				(elem) => elem.recipientId === item.uuid
			);
			const findDefaultCoord = mapStampDeafultcoord.find(
				(ele) => ele.recipientId === item.uuid
			);

			if (findRecp) {
				findRecp.coordinates = [
					...findRecp.coordinates,
					...findDefaultCoord.coordinates
				];
			} else {
				updatedTemplatePayload.recipientData.push(findDefaultCoord);
			}
		}
	} else {
		const mapStampDeafultcoord = mapDefaultFields(
			storedRecipients,
			null,
			false
		);
		storedRecipients.map((item) => {
			const findRecp = updatedTemplatePayload.recipientData.find(
				(elem) => elem.recipientId === item.uuid
			);
			const findDefaultCoord = mapStampDeafultcoord.find(
				(ele) => ele.recipientId === item.uuid
			);

			if (findRecp) {
				findRecp.coordinates = [
					...findRecp.coordinates,
					...findDefaultCoord.coordinates
				];
			} else {
				updatedTemplatePayload.recipientData.push(findDefaultCoord);
			}
		});
	}

	try {
		await addDocumentSign(documentID, updatedTemplatePayload);
		dispatch(setPreviewDataAction(htmlData));
		setTimeout(() => {
			if (setIsLoading) {
				setIsLoading(false);
			}

			navigate(`/templatepreview?esign=${true}&pdf=${false}`);
		}, 300);
	} catch {
		if (setIsLoading) {
			setIsLoading(false);
		}
	}
};

const templateRecipientCoord = async (
	getSignCoordinates,
	tempDiv,
	stampBase64,
	mapRecipients,
	updatedTemplatePayload
) => {
	if (getSignCoordinates.length > 0) {
		for (const el of getSignCoordinates) {
			if (el.dataset.recp) {
				const checkRecp = updatedTemplatePayload.recipientData.find(
					(item) => item.recipientId === el.dataset.recp
				);

				if (!checkRecp) {
					// For getting all the coordinates for a particular recipient
					const coordArr = getIndividualCoordinates(
						el,
						getSignCoordinates,
						stampBase64,
						tempDiv
					);

					updatedTemplatePayload.recipientData.push({
						recipientId: el.dataset.recp,
						coordinates: coordArr.filter(Boolean)
					});
				}
			}
		}
	} else {
		updatedTemplatePayload.recipientData = mapRecipients;
	}
};

const getIndividualCoordinates = (
	el,
	getSignCoordinates,
	stampBase64,
	tempDiv
) =>
	[...getSignCoordinates]
		.map((element) => {
			if (element.dataset.recp === el.dataset.recp) {
				const elid = element.getAttribute('id');

				const findEl = tempDiv.querySelector('#' + elid);

				const pageOffset
					= stampBase64?.length > 0
						? multiply(findEl.offsetTop - 165, stampBase64?.length)
						: findEl.offsetTop;

				const defaultpageNumber = Math.floor(pageOffset / 841) + 1;

				const pageNumber = defaultpageNumber;

				const newPagenumber = pageNumber === 0 ? 1 : pageNumber;

				const offsetTop
					= stampBase64?.length > 0
						? multiply(pageOffset - pageNumber, 8)
						: pageOffset;

				const offsetLeft = findEl.offsetLeft + 1;

				const pageheight = 841;

				// Setting x positon
				const updateX
					= offsetLeft < 200 ? 595 - offsetLeft - 150 : 595 - offsetLeft - 155;
				const checkXpos = offsetLeft < 200 ? updateX + 5 : updateX + 10;
				const chx = checkXpos <= 0 ? 1 : checkXpos;
				// Setting y positon
				const newY = subtract(pageheight * newPagenumber, offsetTop);
				const changeY = newY - 40;
				const checkPostion = changeY > 700 ? changeY - 12 : changeY;
				const negY = checkPostion <= 0 ? 2 : checkPostion;

				return {
					xCoOrdinates: chx,
					yCoOrdinates: negY,
					pageNo: newPagenumber || 1
				};
			}

			return null;
		})
		.filter(Boolean);

export const mapDefaultFields = (storedRecipients, pages, docId) =>
	storedRecipients.map((item, index) => {
		const xcoord = index === 0 ? 1 : multiply(4 + index, 160);
		const tempSubtractedValue1 = subtract(index, 8);
		const tempSubtractedValue2 = subtract(index, 4);

		const updatexcoord
			= index > 7
				? 4 + multiply(tempSubtractedValue1 * 160)
				: 4 + multiply(tempSubtractedValue2 * 160);
		const ycoord = index > 7 ? 140 : 70;

		const coordianteValues = {
			xCoOrdinates: xcoord > 440 ? updatexcoord : xcoord,
			yCoOrdinates: xcoord > 440 ? ycoord : 2,
			pageNo: 1
		};
		const getRecipientId = docId
			? item.docIds?.find((docData) => docData.docId === docId)
			: { uuid: item.uuid };

		return {
			recipientId: getRecipientId.uuid,
			enableOtp: item.enableOtp,
			coordinates: pages
				? pages.map((page, pageIndex) => ({
					...coordianteValues,
					pageNo: pageIndex + 1
				}))
				: [coordianteValues]
		};
	});

export const getRecipientCoord = (signData, pdfData, inputValues) =>
	inputValues.reduce((acc, val) => {
		const newX = val.coord ? val.coord?.x + 1 : 1;
		const xperWidth = val.coord?.pageWidth
			? val.coord?.pageWidth - newX - 150
			: 600 - newX;
		const updatedX = xperWidth <= 0 ? 1 : xperWidth;

		const newY = val.coord?.newY;
		const updatedY = newY <= 0 ? 1 : newY;

		if (pdfData.id === val.pdfId && val.uuid === signData.uuid) {
			acc.push({
				xCoOrdinates: updatedX,
				yCoOrdinates: updatedY,
				pageNo: val.coord?.pageNo
			});
		}

		return acc;
	}, []);

const mapDataFields = (inputValues, pdfData, payloadArr) =>
	inputValues?.length > 0
		? inputValues.forEach((el) => {
			if (pdfData.id === el.pdfId && pdfData.docId === el.pdfdocId) {
				const findEl = payloadArr.recipientData.find(
					(element) => element.recipientId === el.uuid
				);

				if (!findEl) {
					const findRecipients = getRecipientCoord(el, pdfData, inputValues);

					const filterCoord = findRecipients.filter(Boolean);

					payloadArr.recipientData.push({
						recipientId: el.uuid,
						coordinates: filterCoord
					});
				}
			} else {
				payloadArr.recipientData.push('');
			}
		})
		: [];

export const mapInputData = (
	payloadData,
	defaultPdfSign,
	selectedFile,
	storedRecipients,
	setIsLoading,
	inputValues
) => {
	if (defaultPdfSign.enabled) {
		(async () => {
			for (const pdfData of selectedFile) {
				try {
					const loadPdfPages = await PDFDocument.load(pdfData.dataUrl);
					const pages = loadPdfPages.getPages();

					payloadData.documentPdf = pdfData.dataUrl;

					const updatedRecipientData = mapDefaultFields(
						storedRecipients,
						pages,
						pdfData.docId
					);

					payloadData.recipientData = updatedRecipientData;

					const updatedPayload = {
						...payloadData,
						isTemplate: false
					};

					await addDocumentSign(pdfData.docId, updatedPayload);
				} catch {
					if (setIsLoading) {
						setIsLoading(false);
					}
				}
			}
		})();
	} else {
		(async () => {
			for (const item of selectedFile || []) {
				payloadData.docId = item.docId;
				payloadData.recipientData = [];

				const updatedPayload = {
					...payloadData,
					isTemplate: false
				};

				mapDataFields(inputValues, item, updatedPayload);

				const filterData = updatedPayload.recipientData?.filter(
					(recpData) => recpData !== ''
				);

				const enableOtpMap = storedRecipients.reduce((map, recipient) => {
					map[recipient.uuid] = recipient.enableOtp;
					return map;
				}, {});

				const updatedFilterData = filterData.map((recipient) => ({
					...recipient,
					enableOtp: enableOtpMap[recipient.recipientId]
				}));

				updatedPayload.recipientData = updatedFilterData;

				try {
					await addDocumentSign(item.docId, updatedPayload);
				} catch {
					setIsLoading(false);
				}
			}
		})();
	}
};

const getWindowRelativeOffset = async (parent, element) => {
	const elementRect = element.getBoundingClientRect();
	const parentRect = parent.getBoundingClientRect();
	const relativeX = elementRect.left - parentRect.left;
	const relativeY = elementRect.top - parentRect.top;
	return { x: relativeX, y: relativeY };
};

const isEmpty = (value) => !value || value === '';

const getEditorPageSize = (editorPageSize, pageSizes) =>
	editorPageSize ?? pageSizes[0];

export const handleTemplateSave = async ({
	editor,
	createmode,
	dispatch,
	fileId,
	// HoldTemplateName,
	borderData,
	autosave,
	marginData,
	editorPageSize,
	stampConfig,
	shouldexit,
	handleExit,
	pageOrientation,
	additionalCharges,
	isAdditionalAmountRequired,
	templateStatus,
	isAdditionalAmount = false
}) => {
	const { showToast } = customToast();
	const checkData = editor.getData()?.trim();
	const container
		= createmode === 'true' && window.document.querySelector('#editor');

	if (isAdditionalAmount) {
		dispatch(handleAdditionalCharges(false));
	} else if ([checkData, container?.textContent].some((el) => isEmpty(el)) && !autosave) {
		showToast('error', 'Cannot save blank template');
		return false;
	}

	const findDoc = window.document.querySelectorAll('.template-input-selector');
	const fieldsList = [];
	if (findDoc.length > 0) {
		const res = getInputFields(findDoc);
		fieldsList.inputFields = res;
	}

	const findSelectDropDown
		= window.document.querySelectorAll('.template-dropdown');
	const selectDetails = [];
	if (findSelectDropDown?.length) {
		getDropdownFields(findSelectDropDown, selectDetails);
	}

	fieldsList.selectFields = selectDetails;

	const newData = getMobileValue(
		createmode === 'true',
		window.document.querySelector('#editor')?.innerHTML,
		window.document.querySelector('#preview-container')?.innerHTML
	);

	const tempDiv = window.document.createElement('div');

	const modHtml = newData.replaceAll('.', ' .');

	tempDiv.innerHTML = `<div style="width: 796px;">${modHtml}</div>`;

	mapTables(tempDiv);

	dispatch(updateContent(tempDiv.innerHTML));
	const thumbnailData = tempDiv.innerHTML;

	const thumbnail = await generateThumbnail(thumbnailData);
	// Const fields = fieldsList.inputFields?.length ? [fieldsList.inputFields] : [];
	const fields = [
		...(fieldsList.inputFields?.length ? fieldsList.inputFields : []),
		...(fieldsList.selectFields ?? [])
	];

	if (window.document.querySelector('#editor')) {
		window.document.querySelector('#editor').scrollTo(0, 0);
		fields.map(async (f) => {
			if (
				f.isrecipient === 'esign'
				&& window.document.querySelector('#' + f.id)
			) {
				f.coord = await getWindowRelativeOffset(
					window.document.querySelector('.editor-wrapper'),
					window.document.querySelector('#' + f.id)
				);
			}
		});
	}

	if (!thumbnail) {
		console.error('Thumbnail generation failed.');
		return;
	}

	const generateCleanFields = (rawFields) => rawFields.reduce((acc, item) => {
		const base = { id: item.id };

		if (item.id?.startsWith('TR_')) {
			acc.push({
				...base
			});
		} else if (item.id?.startsWith('TS_')) {
			acc.push({
				...base,
				required: item.required || false,
				coord: item.coord
			});
		} else if (item.id?.startsWith('TD_')) {
			acc.push({
				...base,
				min: item.min,
				max: item.max,
				required: item.required || false
			});
		} else if (item.id?.startsWith('TT_')) {
			acc.push({
				...base,
				required: item.required || false
			});
		} else if (item.id?.startsWith('TC_')) {
			acc.push({
				...base,
				value: item.value,
				isChecked: item.isChecked || false
			});
		} else if (item.id?.startsWith('TO_') && item.options && item.options.length > 0) {
			acc.push({
				...base,
				required: item.required || false,
				options: item.options
			});
		}

		return acc;
	}, []);

	const tempStampConfig = stampConfig?.data?.map((item) => ({
		...item,
		...(item.value === 'e-Stamp'
			&& item.considerationPrice !== '' && {
			considerationAmount: Number(item.considerationPrice)
		})
	}));
	const data = {
		templateId: fileId,
		// TemplateName: holdTemplateName,
		templateStatus,
		templateThumbnail: thumbnail,
		templateHtml: tempDiv.innerHTML,
		templatePdfPath: [],
		templateConfig: {
			fields: generateCleanFields(fields),
			borderData: JSON.stringify(borderData),
			marginData: JSON.stringify(marginData),
			editorPageSize: getEditorPageSize(editorPageSize, pageSizes),
			stampConfig: { ...stampConfig, data: tempStampConfig },
			pageOrientation,
			...isAdditionalAmountRequired,
			...additionalCharges
		}
	};

	// StampConfig
	if (stampConfig?.isRecipientToPayStamp) {
		data.templateConfig.isAdditionalAmountRequired = true;
	}

	const response = await updateTemplate(fileId, data);
	if (response.status === 200) {
		if (shouldexit && handleExit) {
			handleExit();
		}

		return response;
	}

	if (!autosave) {
		showToast('error', getErrorMessage(response));
	}

	return response;
};
